class Controller {
  constructor($injector, $mdDialog) {
    "ngInject";
    this.$mdDialog = $mdDialog;
    this.$injector = $injector;
    this.Events = $injector.get("Events");
    this.privateBusRequest = $injector.get("PrivateBusRequests");
    this.selectCaptainEvent = this.Events.getSelectUserEvent();
    this.Events.on(this.selectCaptainEvent, this.onSelectCaptain.bind(this));
  }
  onSelectCaptain(selectedCaptain) {
    this.captain = selectedCaptain._id;
  }
  close() {
    this.$mdDialog.cancel();
  }
  confirm() {
    this.$mdDialog.hide(this.captain);
  }
}
export default Controller;



// WEBPACK FOOTER //
// ./src/pages/privateBusRequest/dialog/dialog.controller.js